import { composeClassNames } from "@faedev/editor-utils";
import { Badge } from "react-bootstrap";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import constants from "src/constants";
import gutter from "src/functions/gutter";
import { sBadge } from "src/styles/sBadge.module.scss";

function showPriceInSubscriptionCard(
  price: number | string,
  currency: string,
  text: string,
  textAsPrice: boolean = false
) {
  currency = constants.Locales._default.currency;
  return (
    <Badge
      pill={true}
      className={composeClassNames([sBadge, "badge-light"])}
      style={gutter(`padding`, `vertical`, `xn`)}
    >
      {text && (
        <Text
          align="center"
          size="xs"
          style={gutter(`margin`, `horizontal`, `xn`)}
        >
          <Translate tKey={text} />
        </Text>
      )}
      {price !== null && (
        <Text
          align="center"
          size="xm"
          style={gutter(`margin`, `horizontal`, `xn`)}
          variant="primary"
          width="semibold"
        >
          {!textAsPrice ? price : <Translate tKey={String(price)} />}
          {!textAsPrice && (
            <>
              {" "}
              <Translate tKey={currency.toUpperCase()} />
            </>
          )}
        </Text>
      )}
    </Badge>
  );
}

export default showPriceInSubscriptionCard;
